import React from 'react';
import PropTypes from 'prop-types';
import { Location } from '@reach/router';

// eslint-disable-next-line
import ThemeTopLayout from 'gatsby-theme-material-ui-top-layout/src/components/top-layout';
import themeDark, { themeLight } from '../../gatsby-theme-material-ui-top-layout/theme';

import Navbar from './Navbar';
import Footer from './Footer';
import CookieConsentBar from '../CookieConsentBar';

const getBaseCategory = (location) => {
  const pattern = '/.*?/';
  const result = location.pathname.match(pattern);
  if (result) {
    return result[0];
  }
  return '/';
};

function Layout({ children, lightTheme, baseCategory }) {
  const theme = lightTheme ? themeLight : themeDark;
  return (
    <Location>
      {({ location }) => {
        return (
          <ThemeTopLayout theme={theme}>
            {/* <CssBaseline /> */}
            <CookieConsentBar />
            <Navbar location={baseCategory || getBaseCategory(location)} />
            {children}
            <Footer />
          </ThemeTopLayout>
        );
      }}
    </Location>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  lightTheme: PropTypes.bool,
  baseCategory: PropTypes.string,
};

Layout.defaultProps = {
  lightTheme: false,
  baseCategory: null,
};

export default Layout;
